import { CULTURES_COUNTRY } from '@openflex/component'
import getCultureCountry from 'core/utils/cultures/country'
import * as defaultFields from './default'
import * as deFields from './de'
import * as esFields from './es'
import * as frFields from './fr'
import * as itFields from './it'

export const getFormFields = type => {
  switch (getCultureCountry()) {
    default:
      return defaultFields.default.formFields[type]
    case CULTURES_COUNTRY.DE:
      return deFields.default.formFields[type]
    case CULTURES_COUNTRY.ES:
      return esFields.default.formFields[type]
    case CULTURES_COUNTRY.FR:
      return frFields.default.formFields[type]
    case CULTURES_COUNTRY.IT:
      return itFields.default.formFields[type]
  }
}

export const checkRequiredAdditionnalFormFields = vehicle => {
  switch (getCultureCountry()) {
    case CULTURES_COUNTRY.ES:
    case CULTURES_COUNTRY.FR:
    case CULTURES_COUNTRY.IT:
    default:
      return true
    case CULTURES_COUNTRY.DE:
      return vehicle && vehicle.trailerHitch
  }
}
